import L from 'leaflet';

const iconCache = {};

export function pendingIcon() {
  if (iconCache.pending) {
    return iconCache.pending;
  }

  const svg = `<svg xmlns="http://www.w3.org/2000/svg" width="36" height="52" viewBox="0 0 36 52" style="pointer-events:none">
    <circle fill="#2563eb" opacity="0.18" cx="18" cy="17" r="17"/>
    <path fill="#2563eb" stroke="#fff" stroke-width="2.5"
      d="M18 5C11.373 5 6 10.373 6 17c0 9.5 12 31 12 31S30 26.5 30 17C30 10.373 24.627 5 18 5z"/>
    <circle fill="white" cx="18" cy="17" r="7.5"/>
    <text x="18" y="21.5" text-anchor="middle" font-size="14" font-weight="bold" fill="#2563eb">+</text>
  </svg>`;

  iconCache.pending = L.divIcon({
    html: svg,
    className: '',
    iconSize: [36, 52],
    iconAnchor: [18, 52],
    popupAnchor: [0, -52]
  });

  return iconCache.pending;
}

export function savedIcon(sequence) {
  const key = `saved-${sequence}`;

  if (iconCache[key]) {
    return iconCache[key];
  }

  const fontSize = sequence > 99 ? 6 : sequence > 9 ? 7 : 9;
  const svg = `<svg xmlns="http://www.w3.org/2000/svg" width="30" height="42" viewBox="0 0 30 42" style="pointer-events:none">
    <filter id="saved-filter-${sequence}"><feDropShadow dx="0" dy="1" stdDeviation="1" flood-opacity="0.25"/></filter>
    <path filter="url(#saved-filter-${sequence})" fill="#059669" stroke="#fff" stroke-width="2"
      d="M15 2C8.373 2 3 7.373 3 14c0 9.5 12 26 12 26S27 23.5 27 14C27 7.373 21.627 2 15 2z"/>
    <circle fill="white" cx="15" cy="14" r="7"/>
    <text x="15" y="${14 + fontSize * 0.45}" text-anchor="middle" font-size="${fontSize}" font-weight="bold" fill="#059669">${sequence}</text>
  </svg>`;

  iconCache[key] = L.divIcon({
    html: svg,
    className: '',
    iconSize: [30, 42],
    iconAnchor: [15, 42],
    popupAnchor: [0, -42]
  });

  return iconCache[key];
}

export function editingIcon(sequence) {
  const key = `editing-${sequence}`;

  if (iconCache[key]) {
    return iconCache[key];
  }

  const fontSize = sequence > 99 ? 6 : sequence > 9 ? 7 : 9;
  const svg = `<svg xmlns="http://www.w3.org/2000/svg" width="36" height="52" viewBox="0 0 36 52" style="pointer-events:none">
    <circle fill="#7c3aed" opacity="0.15" cx="18" cy="17" r="17"/>
    <path fill="#7c3aed" stroke="#fff" stroke-width="2.5"
      d="M18 5C11.373 5 6 10.373 6 17c0 9.5 12 31 12 31S30 26.5 30 17C30 10.373 24.627 5 18 5z"/>
    <circle fill="white" cx="18" cy="17" r="7.5"/>
    <text x="18" y="${17 + fontSize * 0.45}" text-anchor="middle" font-size="${fontSize}" font-weight="bold" fill="#7c3aed">${sequence}</text>
  </svg>`;

  iconCache[key] = L.divIcon({
    html: svg,
    className: '',
    iconSize: [36, 52],
    iconAnchor: [18, 52],
    popupAnchor: [0, -52]
  });

  return iconCache[key];
}

// Small non-interactive pill used to label a route segment's distance at its
// midpoint. Not cached (text varies).
export function distanceLabelIcon(text) {
  const html = `<div style="transform:translate(-50%,-50%);display:inline-block;white-space:nowrap;background:rgba(255,255,255,0.95);border:1px solid #e2e8f0;border-radius:9999px;padding:1px 7px;font-size:10px;font-weight:600;color:#475569;box-shadow:0 1px 2px rgba(15,23,42,0.15);font-family:Inter,ui-sans-serif,sans-serif">${text}</div>`;
  return L.divIcon({ html, className: '', iconSize: [0, 0], iconAnchor: [0, 0] });
}

export function routeStopIcon(sequence) {
  const key = `route-${sequence}`;

  if (iconCache[key]) {
    return iconCache[key];
  }

  const fontSize = sequence > 99 ? 6 : sequence > 9 ? 7 : 9;
  const svg = `<svg xmlns="http://www.w3.org/2000/svg" width="30" height="42" viewBox="0 0 30 42" style="pointer-events:none">
    <filter id="route-filter-${sequence}"><feDropShadow dx="0" dy="1" stdDeviation="1" flood-opacity="0.25"/></filter>
    <path filter="url(#route-filter-${sequence})" fill="#2563eb" stroke="#fff" stroke-width="2"
      d="M15 2C8.373 2 3 7.373 3 14c0 9.5 12 26 12 26S27 23.5 27 14C27 7.373 21.627 2 15 2z"/>
    <circle fill="white" cx="15" cy="14" r="7"/>
    <text x="15" y="${14 + fontSize * 0.45}" text-anchor="middle" font-size="${fontSize}" font-weight="bold" fill="#2563eb">${sequence}</text>
  </svg>`;

  iconCache[key] = L.divIcon({
    html: svg,
    className: '',
    iconSize: [30, 42],
    iconAnchor: [15, 42],
    popupAnchor: [0, -42]
  });

  return iconCache[key];
}
